// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kiH_","clinicsSelect":"styles_clinicsSelect__1xRxV"};